/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useContext, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "UIComponents/LayoutContainers/DashboardLayout";
import DashboardNavbar from "UIComponents/Navbars/DashboardNavbar";
import Footer from "UIComponents/Footer";
import { useTranslation } from "react-i18next";
import { ModalContext } from "context/ModalContext";
import DataTable from "UIComponents/Tables/DataTable";

// Data
import data from "layouts/Requests/components/data";
import RequestForm from "./components/RequestForm";
import MDDialog from "components/MDDialog";

function Privacy() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const modalContext = useContext(ModalContext);
  const onEdit = () => {
    modalContext.show();
    modalContext.setComponent(<RequestForm />);
  };
  const onView = () => {
    modalContext.show();
    modalContext.setComponent(<RequestForm view />);
  };
  const onDelete = () => {
    setOpen(true);
  };
  const { columns, rows } = data({ onEdit, onView, onDelete });

  return (
    <>
      <MDBox pt={2} mb={2} ml={-1} px={2} lineHeight={1.25}>
        <MDTypography variant="h6" fontWeight="medium">
          {t("headings.requests")}
        </MDTypography>
        <MDBox mb={1}>
          <MDTypography variant="button" color="text">
            {t("captions.requests")}
          </MDTypography>
        </MDBox>
      </MDBox>
      <MDBox mt={6} mb={3}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={12}>
            <Card sx={{ minHeight: "65vh" }}>
              <MDBox p={2}>
                <DataTable
                  table={{ columns, rows }}
                  showTotalEntries={false}
                  isSorted={false}
                  noEndBorder
                  entriesPerPage={false}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <MDDialog
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        title={"آیا مطمئنید؟"}
      />
    </>
  );
}

export default Privacy;
